import {DealType} from "@irati/types"

export interface FilterOption {
  label: string
  value: DealType[]
}

export const MERCHANDISE = {
  label: "perks.deals.dealFilter.rewardType.merchandise.label",
  value: [DealType.Merchandise]
}

export const VOUCHERS = {
  label: "perks.deals.dealFilter.rewardType.vouchers.label",
  value: [DealType.Classic, DealType.External]
}

export const DEFAULT_OPTION = []

const dataRewardBy = {OPTIONS: [MERCHANDISE, VOUCHERS], MERCHANDISE, VOUCHERS, DEFAULT_OPTION}

export default dataRewardBy
